import { Button, QrCode, formatDate, titleCase, toast } from '@westhetics/ui'
import { useState } from 'react'
import { copyText } from './labels'

/**
 * O link da anamnese ao alcance da clínica (RN-ANA-03, canal `link`): o endereço copiável e o QR,
 * gerado no app a partir do próprio endereço, sem chamada à API. Aparece depois de emitir com
 * "Só o link", quando o provedor do canal está fora e no registro da anamnese não preenchida.
 */

export const LINK_COPIED = 'Link copiado. Vale por 7 dias.'

export function LinkPanel({
  url,
  patientName,
  expiresAt,
  defaultQrOpen = false,
  className,
}: {
  url: string
  patientName: string
  /** Até quando o link vale (ISO). */
  expiresAt?: string
  defaultQrOpen?: boolean
  className?: string
}) {
  const [copy, setCopy] = useState<'idle' | 'copied' | 'failed'>('idle')
  const [qrOpen, setQrOpen] = useState(defaultQrOpen)
  const name = titleCase(patientName)
  const validity = expiresAt ? ` O link vale até ${formatDate(new Date(expiresAt))}.` : ''

  async function copyLink() {
    if (await copyText(url)) {
      setCopy('copied')
      toast(LINK_COPIED)
    } else {
      setCopy('failed')
    }
  }

  return (
    <div className={className}>
      <div className="eyebrow">Link da anamnese</div>
      <code className="border-hairline-strong bg-pampas font-body text-ink mt-[6px] block border px-[14px] py-3 text-[12px] leading-[1.5] font-light break-all select-all">
        {url}
      </code>
      <div className="mt-3 flex flex-wrap items-center gap-4">
        <Button variant="outline" onClick={() => void copyLink()}>
          {copy === 'copied' ? 'Link copiado' : 'Copiar link'}
        </Button>
        <Button variant="text" aria-expanded={qrOpen} onClick={() => setQrOpen((open) => !open)}>
          {qrOpen ? 'Fechar QR' : 'Abrir QR'}
        </Button>
      </div>
      {copy === 'failed' ? (
        <p role="alert" className="font-body text-plum mt-2 text-[12px] leading-[1.6] font-light">
          O navegador não deixou copiar. Selecione o link acima e copie à mão.
        </p>
      ) : null}
      {qrOpen ? (
        <div className="mt-4 flex flex-wrap items-center gap-5">
          <QrCode value={url} label={`Código QR do link da anamnese de ${name}`} />
          <p className="font-body text-body text-secondary max-w-[280px] font-light">
            Aponte a câmera do celular de {name} para o código. Ele abre o mesmo link, sem cadastro
            nem senha.{validity}
          </p>
        </div>
      ) : null}
    </div>
  )
}
